import React from 'react';
import styles from '../styles/GamePage.module.css';
import { Link } from 'react-router-dom';
import Kaiya from '../components/kaiya';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Games = () => {
    return (
        <>
         <Navbar />
        <div className={styles.gamesPage}>
            <div className={styles.heroSection}>
                <h1>Bakso Games</h1>
                <p>Fun interactive games featuring your favorite tiger cub!</p>
            </div>

            <div className={styles.mainContent}>
                <div className={styles.gamesSection}>
                    <h2 className={styles.sectionTitle}>Available Games</h2>
                    <div className={styles.tigerDivider}></div>
                    
                    <div className={styles.gamesGrid}>
                        {/* Bakso Jump Game */}
                        <div className={styles.gameCard}>
                            <div className={styles.gameImageContainer}>
                                <img src="/assets/jungle-bg.png" alt="Bakso Jump Game" className={styles.gameImage} />
                            </div>
                            <div className={styles.gameContent}>
                                <h3 className={styles.gameTitle}>Bakso Jump</h3>
                                <p className={styles.gameDescription}>
                                    Help Bakso navigate through the jungle by jumping over obstacles! 
                                    Test your reflexes in this fun, fast-paced game inspired by classic 
                                    endless runners.
                                </p>
                                <div className={styles.gameDetails}>
                                    <div className={styles.gameFeature}>
                                        <span className={styles.featureLabel}>Difficulty:</span>
                                        <span className={styles.featureValue}>Medium</span>
                                    </div>
                                    <div className={styles.gameFeature}>
                                        <span className={styles.featureLabel}>Type:</span>
                                        <span className={styles.featureValue}>Endless Runner</span>
                                    </div>
                                </div>
                                <Link to="/baksogame" className={styles.playButton}>
                                    Play Now 🐾
                                </Link>
                            </div>
                        </div>

                        {/* Coming Soon Placeholder - use this to ensure mobile layout shows 2 per row */}
                        <div className={styles.gameCard + ' ' + styles.comingSoon}>
                            <div className={styles.gameImageContainer}>
                                <div className={styles.comingSoonOverlay}>
                                    <span>Coming Soon</span>
                                </div>
                                <img src="/images/coming-soon-game.png" alt="Coming Soon" className={styles.gameImage} 
                                     onError={(e) => {
                                         // Fallback for missing image
                                         const target = e.target as HTMLImageElement;
                                         target.src = "/jungle-bg.png"; 
                                     }}/>
                            </div>
                            <div className={styles.gameContent}>
                                <h3 className={styles.gameTitle}>Tiger Trek</h3>
                                <p className={styles.gameDescription}>
                                    An exciting new adventure game where you'll help Bakso explore 
                                    the Sumatran Jungle, solve puzzles, and discover hidden treasures.
                                    Stay tuned for this upcoming release!
                                </p>
                                <div className={styles.gameDetails}>
                                    <div className={styles.gameFeature}>
                                        <span className={styles.featureLabel}>Difficulty:</span>
                                        <span className={styles.featureValue}>Medium</span>
                                    </div>
                                    <div className={styles.gameFeature}>
                                        <span className={styles.featureLabel}>Type:</span>
                                        <span className={styles.featureValue}>Adventure</span>
                                    </div>
                                </div>
                                <button className={styles.disabledButton}>
                                    Coming Soon 🐾
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={styles.suggestGameSection}>
                    <h2 className={styles.sectionTitle}>Game Suggestions</h2>
                    <div className={styles.tigerDivider}></div>
                    <p className={styles.suggestText}>
                        Have an idea for a Bakso-themed game? Join our Telegram community and share your suggestions!
                        We're always looking for fun new ways to bring Bakso's adventures to life.
                    </p>
                    <a 
                        href="https://t.me/baksosolportal" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className={styles.suggestButton}
                    >
                        Join Telegram Community
                    </a>
                </div>
            </div>
            
        </div>
        <Footer />
        <Kaiya />
        </>
    );
};

export default Games;